module.exports = __webpack_public_path__ + "static/media/lucas_paus.33c6b25f.png";